import { render } from "./dictionary.vue?vue&type=template&id=38ba1bfe&ts=true"
import script from "./dictionary.vue?vue&type=script&lang=ts"
export * from "./dictionary.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__